import { useMutation, useQueryClient } from '@tanstack/react-query';
import client from '../client';

export type EvidenceUploadInput = {
  taxYear: number;
  file: File;
  kind: string;
  sha256: string;
  openItemId?: string;
  lineItemIds?: string[];
};

export function useEvidenceUpload() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ taxYear, file, kind, sha256, openItemId, lineItemIds = [] }: EvidenceUploadInput) => {
      const body = new FormData();
      body.append('file', file);
      body.append('kind', kind);
      body.append('sha256', sha256);
      body.append('line_item_ids', JSON.stringify(lineItemIds));
      if (openItemId) body.append('open_item_id', openItemId);
      const response = await client.post(`/api/business/year/${taxYear}/evidence`, body);
      return response.data;
    },
    onSuccess: (_data, input) => {
      void queryClient.invalidateQueries({ queryKey: ['accountant-open-items'] });
      void queryClient.invalidateQueries({ queryKey: ['business-accountant-work', input.taxYear] });
    },
  });
}

